<!-- <nav class="ui-nav rowRight">
<div #innerBarRef class="innerBar rowRight glass-effect">
<div #cutoutRef class="ui-cutout" [ngClass]="isTabChecked('/accounts') ? 'hideCut' : 'showCut'">
<div #cutoutClassRef class="indicatorTab cutoutTransition" [ngClass]="cutoutClass"></div>
</div>


<div *ngFor="let tab of tabs; let i = index" [id]="tab.id" class="ui-label" (click)="onTabClick(tab.route, i)" [ngClass]="isTabChecked(tab.route) ? 'selected' : 'not-selected'">
<ion-icon [src]="tab.iconSvgPath" class="iconF" [ngClass]="iconColors[i]"></ion-icon>
</div>
</div>


<div #uiLastRef class="uiLast glass-effect" id="tab-4" (click)="onTabClick('/accounts')" [ngClass]="isTabChecked('/accounts') ? 'selectedLast' : 'not-selectedLast'">
<ion-icon src="/assets/svg/user.svg"></ion-icon>
</div>
</nav> -->
<div class="slider-container rowRight" #container>
  <div class="slider-handle" #handle>
    <div class="jiggler"></div>
  </div>
  <div class="marker" (click)="setPosition('/calendar')" [ngClass]="canClick('/calendar')">
<ion-icon src="/assets/svg/calendar.svg" class="iconF" [ngClass]="iconColors('/calendar')"></ion-icon>
  </div>
    <div class="marker" (click)="setPosition('/menu')" [ngClass]="canClick('/menu')">
<ion-icon src="/assets/svg/menu-n.svg" class="iconF" [ngClass]="iconColors('/menu')"></ion-icon>
  </div>
    <div class="marker" (click)="setPosition('/order')" [ngClass]="canClick('/order')">
<ion-icon src="/assets/svg/carts.svg" class="iconF" [ngClass]="iconColors('/order')"></ion-icon>
  </div>

</div>
  <div class="uiLast" (click)="setPosition('/accounts')" [ngClass]="currentRoute === '/accounts' ? 'selectedLast' : ''">
<ion-icon src="/assets/svg/user.svg" class="iconF" [ngClass]="iconColors('/accounts')"></ion-icon>
  </div>


